const { createTheme } = require("@mui/material");

const theme = createTheme({
  typography: {
    fontFamily: "AnjomanMax",
  },
  palette: "dark",
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true, // Disable ripple effect globally
      },
    },
  },
});

export default theme;
